import React from 'react';

import { noOp } from '@neslotech/utils';

import { Profile } from '../interfaces/profile/profile.interface';

// Mirrors HrAuthorization::HR_PRIVILEGED_ROLES on the API.  Gating HR screens
// on `isAdmin` alone would lock out roles the backend does permit.
export const HR_PRIVILEGED_ROLES = ['admin', 'human_resources', 'manager'];

export interface AuthProps {
  token: string | null;
  profile?: Profile;
  setToken: (value: string) => void;
  onLogout: () => void;
  isAdmin: boolean;
  isHrPrivileged: boolean;
}

export const AuthContext = React.createContext<AuthProps>({
  token: null,
  onLogout: noOp,
  setToken: noOp,
  isAdmin: false,
  isHrPrivileged: false
});
